import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import {
  CustomerSearchCriteria,
  FabricStyleSearchCriteria,
  PageListBean,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  RestSalesOrderListRequest,
  SalesOrderSearchCriteria,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import {
  DatePickerComponent,
  InputTextbox,
  ShowError,
  ProgressBar,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import { ConfigManager } from "../config/ConfigManager.js";
export class SalesOrderLookupHandler extends LookupHandler {
  static contextType = AppContext;
  constructor(
    companyCode,
    attribute_name,
    fabricStyleCode,
    colorCode,
    orderStatus
  ) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.fabricStyleCode = fabricStyleCode;
    this.colorCode = colorCode;
    this.orderStatus = orderStatus;
    let resetCriteria = new SalesOrderSearchCriteria();
    resetCriteria.companyCode = companyCode;
    resetCriteria.fabricStyleCode = this.fabricStyleCode;
    resetCriteria.fabricStyleColorCode = this.colorCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new SalesOrderSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let salesOrderLookupCriteria = new SalesOrderSearchCriteria();
    salesOrderLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = SalesLookupCriteraHandler(
      companyCode,
      salesOrderLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      salesOrderLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getSalesOrderStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition("Customer", "customerCode", 0, false); //2
    this.addColumnDefinition("CustomerName", "customerName", 0, false); //3
    this.addColumnDefinition("Item", "fabricStyleCode", 0, false); //3
    this.addColumnDefinition("OrderDate", "orderDate", 0, false); //3
    this.addColumnDefinition("Status", "orderStatus", 0, false); //4
    this.addColumnDefinition(
      "CustPurchaseOrder#",
      "customerPurchaseOrderNumber",
      0,
      false
    ); //5
    this.addColumnDefinition("TotalAmount", "grandTotalAmount", 0, false); //3
  }
  loadSalesOrderList = (lookup_dialog, pageNumber, searchCriteria) => {
    let sales_criteria = new SalesOrderSearchCriteria(); //To be fetched from CriteriaHandler
    sales_criteria.companyCode = this.companyCode;
    sales_criteria.fabricStyleCode = this.fabricStyleCode;
    sales_criteria.fabricStyleColorCode = this.colorCode;

    sales_criteria.customerPurchaseOrderNumber = this.purchaseOrderNumber;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      sales_criteria.salesOrderNumber = searchCriteria.salesOrderNumber;
      sales_criteria.customerCode = searchCriteria.customerCode;
      sales_criteria.salesOrderNumberContains =
        searchCriteria.salesOrderNumberContains;
      sales_criteria.salesOrderNumberStartsWith =
        searchCriteria.salesOrderNumberStartsWith;
      sales_criteria.createdDate = searchCriteria.createdDate;
      sales_criteria.paymentTermCode = searchCriteria.paymentTermCode;
      sales_criteria.paymentMethodCode = searchCriteria.paymentMethodCode;
      sales_criteria.shipViaCode = searchCriteria.shipViaCode;
      sales_criteria.orderStopDatefrom = searchCriteria.orderStopDatefrom;
      sales_criteria.orderStopDateTo = searchCriteria.orderStopDateTo;
      sales_criteria.fabricStyleCode = searchCriteria.fabricStyleCode;
      sales_criteria.fabricStyleColorCode = searchCriteria.fabricStyleColorCode;
      sales_criteria.customerPurchaseOrderNumberContains =
        searchCriteria.customerPurchaseOrderNumberContains;
      sales_criteria.customerPurchaseOrderNumberStartsWith =
        searchCriteria.customerPurchaseOrderNumberStartsWith;
      if (!isEmptyString(this.orderStatus)) {
        sales_criteria.orderStatus = this.orderStatus;
      } else {
        sales_criteria.orderStatus = searchCriteria.orderStatus;
      }
    }
    let sales_pageList = new PageListBean();
    sales_pageList.pageSize = 50; //TODO --> Fetch from Config
    sales_pageList.currentPage = pageNumber;
    sales_pageList.pageNumber = pageNumber;
    let sales_requestInput = new RestSalesOrderListRequest();
    sales_requestInput.pageInput = sales_pageList;
    sales_requestInput.searchCriteria = sales_criteria;
    SalesOrderService.getSalesOrderPageList(
      sales_requestInput,
      (response) => this.loadSalesOrderListResponse(response, lookup_dialog),
      this.loadSalesOrderListError
    );
  };
  loadSalesOrderListResponse = (response, lookup_dialog) => {
    let salesOrderList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.salesOrderPageList != null &&
      response.data.salesOrderPageList.salesOrders !== null
    ) {
      salesOrderList = response.data.salesOrderPageList.salesOrders;
      totalCount = response.data.salesOrderPageList.totalCount;
      currentPageNumber = response.data.salesOrderPageList.currentPage;
      pageSize = response.data.salesOrderPageList.pageSize;
      salesOrderList.map((sl) => {
        sl.orderStatus = ModuleUtils.getSalesOrderStatusCaption(sl.orderStatus);
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = salesOrderList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadSalesOrderListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.salesOrderNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.salesOrderNumberContains = filterText;
        this.searchCriteria = new SalesOrderSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadSalesOrderList(lookup_dialog, pageNumber, search);
    }
  }
}
const SalesLookupCriteraHandler = (companyCode, salesOrderLookupCriteria) => {
  return class extends React.Component {
    static contextType = AppContext;
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new SalesOrderSearchCriteria(),
        shipViaCodes: [],
        paymentMethods: [],
        paymentTerms: [],
        shipViaPageListForAutoCompleteList: new Array(),
        showAutoCompleteShipViaList: true,
        showAutoCompletePaymentTypeList: true,
        paymentTypePageListForAutoCompleteList: new Array(),
        showAutoCompletePaymentTermList: true,
        paymentTermPageListForAutoCompleteList: new Array(),
        customerPageListForAutoCompleteList: new Array(),
        fabricPageListForAutoCompleteList: new Array(),
        showAutoCompleteCustomerList: true,
        showAutoCompleteFabricList: true,
        is3PL: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      const { appData } = this.context;
      const { cache } = appData;
      this.cache = cache;
      if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
        this.state.is3PL = true;
        this.setState({
          is3PL: true,
        });
      }
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
      this.loadCacheDetails();
      this.initLookupHandlers();
    }
    loadCacheDetails = () => {
      const attribute_cache = { ...this.cache };
      this.state.paymentMethods = [];
      let paymentMethods_temp=[];
      let paymentMethods = attribute_cache.paymentMethods;
      paymentMethods.map((line) => {
       paymentMethods_temp.push(line);
         this.state.paymentMethods=ModuleUtils.isActiveAttribute(paymentMethods_temp);
      });
      this.state.shipViaCodes = [];
      let shipViaCodes = attribute_cache.shipVias;
      let shipViaCodes_temp=[];
      shipViaCodes.map((shipViaCode) => {
       shipViaCodes_temp.push(shipViaCode);
        this.state.shipViaCodes=ModuleUtils.isActiveAttribute(shipViaCodes_temp);
      });
      this.state.paymentTerms = [];
      let paymentTerms = attribute_cache.paymentTerms;
      let paymentTerms_temp=[];
      paymentTerms.map((line) => {
        paymentTerms_temp.push(line);
         this.state.paymentTerms=ModuleUtils.isActiveAttribute(paymentTerms_temp);
      });
    };
    initLookupHandlers = () => {
      let customerLookupHandler = new CustomerLookupHandler(
        companyCode,
        "Customer"
      );
      this.setState({ customerLookupHandler: customerLookupHandler });
      let shipViaLookupHandler = new GenericAttributeLookupHandler(
        this.state.shipViaCodes,
        "ShipVia"
      );
      this.setState({ shipViaLookupHandler: shipViaLookupHandler });
      let fabricLookupHandler = new FabricStyleLookupHandler(
        companyCode,
        this.state.is3PL ? "Item" : "Fabric Style"
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
      let paymentTermLookupHandler = new GenericAttributeLookupHandler(
        this.state.paymentTerms,
        "Payment Term"
      );
      this.setState({ paymentTermLookupHandler: paymentTermLookupHandler });

      let paymentMethodLookupHandler = new GenericAttributeLookupHandler(
        this.state.paymentMethods,
        "Payment Method"
      );
      this.setState({ paymentMethodLookupHandler: paymentMethodLookupHandler });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new SalesOrderSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({
        searchCriteria: searchCriteria,
        isShowColorLookup: false,
        colorLookupHandler: null,
      });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    onShipViaChange = (e) => {
      let shipViaCode = e.target.value;
      this.state.showAutoCompleteShipViaList = true;

      let temp_searchcriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteShipViaList;

      if (isEmpty(shipViaCode)) {
        this.state.showAutoCompleteShipViaList = false;
        let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
        let temp_searchcriteria = this.state.searchCriteria;
        temp_searchcriteria.shipViaCode = "";

        let suggestion = [];

        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: temp_searchcriteria,
          shipViaPageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && shipViaCode !== "") {
        this.readShipViaBySearchString(shipViaCode);
      }
      if (e.target.name == "shipViaCode") {
        temp_searchcriteria["shipViaCode"] = e.target.value;
        let shipViaCode_List = this.state.shipViaCodes;
        shipViaCode_List.map((shipViaCode) => {
          if (shipViaCode.code == e.target.value) {
            temp_searchcriteria["shipViaCode"] = shipViaCode.code;

            this.state.showAutoCompleteShipViaList = false;
            let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
            this.setState({ showAutoCompleteList: showAutoCompleteList });
          }
        });
      }
      this.setState({ searchCriteria: temp_searchcriteria });
    };
    readShipViaBySearchString(searchString) {
      let shipViaCodeData = this.state.shipViaCodes;
      let simpleAutoCompleteList = new Array();
      if (shipViaCodeData.length > 0 && shipViaCodeData != null) {
        shipViaCodeData.map((shipViaCodeDatas) => {
          let simpleItemBean = {
            code: shipViaCodeDatas.code,
            description: shipViaCodeDatas.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;

      let filteredSuggestions = new Array();

      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompleteShipViaLists) =>
          simpleAutoCompleteShipViaLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        shipViaPageListForAutoCompleteList: filteredSuggestions,
      });
    }
    shipViaEnterKeyEvent = (e) => {
      let temp_searchcriteria = this.state.searchCriteria;
      let shipViaCode = e.target.value;

      temp_searchcriteria["shipViaCode"] = shipViaCode;
      let shipViaList = this.state.shipViaCodes;
      let shipViaBean = null;
      shipViaList.map((shipVia_List) => {
        if (shipVia_List.code == e.target.value) {
          shipViaBean = shipVia_List;
        }
      });
      if (!isEmpty(shipViaBean)) {
        let temp_searchcriteria = this.state.searchCriteria;
        temp_searchcriteria.shipViaCode = shipViaBean.code;

        this.setState({
          searchCriteria: temp_searchcriteria,
          shipViaPageListForAutoCompleteList: new Array(),
        });
      }
    };
    displayAutoCompleteShipViaList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteShipViaList: showAutoCompleteList });
    };
    fabricCodeOnChange = (e) => {
      let fabricStyleCode = e.target.value;
      this.state.showAutoCompleteFabricList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      if (isEmpty(fabricStyleCode)) {
        this.state.showAutoCompleteFabricList = false;
        let showAutoCompleteList = this.state.showAutoCompleteFabricList;
        let criteria = this.state.searchCriteria;
        criteria.fabricStyleCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteFabricList: showAutoCompleteList,
          searchCriteria: criteria,
          fabricPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "fabricStyleCode" &&
        showAutoCompleteList === true &&
        fabricStyleCode !== ""
      ) {
        this.readFabricBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readandsetFabricStyleDetailResponse = (response) => {
      let criteria = this.state.searchCriteria;
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      if (response.data != null && response.data.fabricStyle != null) {
        let fabricStyle = response.data.fabricStyle;
        if (!isEmpty(fabricStyle)) {
          criteria.fabricStyleCode = fabricStyle.code;
          this.setState({
            searchCriteria: criteria,
          });
        }
      }
    };
    readandsetFabricStyleDetail = (fabricStyleCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = fabricStyleCode;
      FabricStyleService.readFabricStyle(
        input,
        this.readandsetFabricStyleDetailResponse,
        this.errorCallBack
      );
    };

    readFabricBySearchString(searchString) {
      let searchCriteria = new FabricStyleSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.fabricStyleCodeStartsWith = searchString;
      searchCriteria.fabricStyleNameStartsWith = searchString;
      let pageList = new RestPageListBean();
      pageList.pageSize = 100;
      let input = new RestFabricStyleListBeanRequest();
      input.companyCode = companyCode;
      input.pageInput = pageList;
      input.code = searchString;
      input.searchCriteria = searchCriteria;
      FabricStyleService.getActiveFabricStylesForAutoComplete(
        input,
        this.readByFabricCodeResponse,
        this.errorCallBack
      );
    }
    readByFabricCodeResponse = (response) => {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    };
    fabricEnterKeyEventHandler = (e) => {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Reading ...",
      });
      this.readandsetFabricStyleDetail(e.target.value);
      this.setState({ fabricPageListForAutoCompleteList: new Array() });
    };
    displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
      this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
    };
    customerCodeOnChange = (e) => {
      let customerCode = e.target.value;
      this.state.showAutoCompleteCustomerList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      if (isEmpty(customerCode)) {
        this.state.showAutoCompleteCustomerList = false;
        let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
        let criteria = this.state.searchCriteria;
        criteria.customerCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteCustomerList: showAutoCompleteList,
          searchCriteria: criteria,
          customerPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "customerCode" &&
        showAutoCompleteList === true &&
        customerCode !== ""
      ) {
        this.readCustomerBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readCustomer = (customerCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = customerCode;
      CustomerService.readCustomer(
        input,
        this.editCustomerResponse,
        this.errorCallBack
      );
    };
    editCustomerResponse = (response) => {
      if (response.data.customer != null) {
        let searchCriteria = response.data.customer;
        let criteria = this.state.searchCriteria;
        criteria.customerCode = searchCriteria.code;
        this.setState({ searchCriteria: criteria });
      }
    };
    readCustomerBySearchString(searchString) {
      let searchCriteria = new CustomerSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.customerCodeStartsWith = searchString;
      searchCriteria.customerNameContains = searchString;
      let cust_pageList = new RestPageListBean();
      cust_pageList.pageSize = 100;
      let cust_requestInput = new RestCustomerListRequest();
      cust_requestInput.pageInput = cust_pageList;
      cust_requestInput.searchCriteria = searchCriteria;
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.readByCustomerCodeResponse,
        this.errorCallBack
      );
    }
    readByCustomerCodeResponse = (response) => {
      let searchCriteria = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (searchCriteria.length > 0 && searchCriteria != null) {
        searchCriteria.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    };
    errorCallBack = (error) => {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      ShowError(error);
    };
    customerCodeEnterKeyEventHandler = (e) => {
      let customerCode = e.target.value;
      this.readCustomer(customerCode);
      this.setState({
        customerPageListForAutoCompleteList: new Array(),
      });
    };
    displayAutoCompleteList = (showAutoCompleteList) => {
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
      });
    };
    onPaymentTermChange = (e) => {
      let paymentTermCode = e.target.value;
      this.state.showAutoCompletePaymentTermList = true;
      let temp_searchcriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
      if (isEmpty(paymentTermCode)) {
        this.state.showAutoCompletePaymentTermList = false;
        let showAutoCompleteList = this.state.showAutoCompletePaymentTermList;
        let temp_searchcriteria = this.state.searchCriteria;
        temp_searchcriteria.paymentTermCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: temp_searchcriteria,
          paymentTermPageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && paymentTermCode !== "") {
        this.readPaymentTermCodeBySearchString(paymentTermCode);
      }
      if (e.target.name == "paymentTermCode") {
        temp_searchcriteria["paymentTermCode"] = e.target.value;
        let paymentTermsCode_List = this.state.paymentTerms;
        paymentTermsCode_List.map((paymentTermCode) => {
          if (paymentTermCode.code == e.target.value) {
            temp_searchcriteria["paymentTermCode"] = paymentTermCode.code;

            this.state.showAutoCompletePaymentTermList = false;
            let showAutoCompleteList =
              this.state.showAutoCompletePaymentTermList;
            this.setState({ showAutoCompleteList: showAutoCompleteList });
          }
        });
      }
      this.setState({ searchCriteria: temp_searchcriteria });
    };
    readPaymentTermCodeBySearchString(searchString) {
      let paymentTermCodeData = this.state.paymentTerms;
      let simpleAutoCompleteList = new Array();
      if (paymentTermCodeData.length > 0 && paymentTermCodeData != null) {
        paymentTermCodeData.map((paymentTermCodeDatas) => {
          let simpleItemBean = {
            code: paymentTermCodeDatas.code,
            description: paymentTermCodeDatas.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;
      let filteredSuggestions = new Array();

      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompletepaymentTypeCodeDataLists) =>
          simpleAutoCompletepaymentTypeCodeDataLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        paymentTermPageListForAutoCompleteList: filteredSuggestions,
      });
    }
    paymentTermEnterKeyEventHandler = (e) => {
      let temp_searchcriteria = this.state.searchCriteria;
      let paymentTermCode = e.target.value;
      temp_searchcriteria["paymentTermCode"] = paymentTermCode;
      let paymentTermsCode_List = this.state.paymentTerms;
      let paymentTermCodeBean = null;
      paymentTermsCode_List.map((paymentTermCode) => {
        if (paymentTermCode.code == e.target.value) {
          paymentTermCodeBean = paymentTermCode;
        }
      });
      if (!isEmpty(paymentTermCodeBean)) {
        let temp_searchcriteria = this.state.searchCriteria;
        temp_searchcriteria.paymentTermCode = paymentTermCodeBean.code;
        this.setState({
          searchCriteria: temp_searchcriteria,
          paymentTermPageListForAutoCompleteList: new Array(),
        });
      }
    };
    onPaymentTypeChange = (e) => {
      let paymentMethodCode = e.target.value;
      this.state.showAutoCompletePaymentTypeList = true;
      let temp_searchcriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompletePaymentTypeList;
      if (isEmpty(paymentMethodCode)) {
        this.state.showAutoCompletePaymentTypeList = false;
        let showAutoCompleteList = this.state.showAutoCompletePaymentTypeList;
        let temp_searchcriteria = this.state.searchCriteria;
        temp_searchcriteria.paymentMethodCode = "";

        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: temp_searchcriteria,
          paymentTypePageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && paymentMethodCode !== "") {
        this.readPaymentTypeCodeBySearchString(paymentMethodCode);
      }
      if (e.target.name == "paymentMethodCode") {
        temp_searchcriteria["paymentMethodCode"] = e.target.value;
        let paymentMethodCode_List = this.state.paymentMethods;
        paymentMethodCode_List.map((paymentMethodCode) => {
          if (paymentMethodCode.code == e.target.value) {
            temp_searchcriteria["paymentMethodCode"] = paymentMethodCode.code;

            this.state.showAutoCompletePaymentTypeList = false;
            let showAutoCompleteList =
              this.state.showAutoCompletePaymentTypeList;
            this.setState({ showAutoCompleteList: showAutoCompleteList });
          }
        });
      }
      this.setState({ searchCriteria: temp_searchcriteria });
    };
    readPaymentTypeCodeBySearchString(searchString) {
      let paymentTypeCodeData = this.state.paymentMethods;
      let simpleAutoCompleteList = new Array();
      if (paymentTypeCodeData.length > 0 && paymentTypeCodeData != null) {
        paymentTypeCodeData.map((paymentTypeCodeDatas) => {
          let simpleItemBean = {
            code: paymentTypeCodeDatas.code,
            description: paymentTypeCodeDatas.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;
      let filteredSuggestions = new Array();
      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompletepaymentTypeCodeDataLists) =>
          simpleAutoCompletepaymentTypeCodeDataLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        paymentTypePageListForAutoCompleteList: filteredSuggestions,
      });
    }
    paymentTypeEnterKeyEventHandler = (e) => {
      let temp_searchcriteria = this.state.searchCriteria;
      let paymentMethodCode = e.target.value;
      temp_searchcriteria["paymentMethodCode"] = paymentMethodCode;
      let paymentMethodCode_List = this.state.paymentMethods;
      let paymentTypeCodeBean = null;
      paymentMethodCode_List.map((paymentMethodCode) => {
        if (paymentMethodCode.code == e.target.value) {
          paymentTypeCodeBean = paymentMethodCode;
        }
      });
      if (!isEmpty(paymentTypeCodeBean)) {
        let temp_searchcriteria = this.state.searchCriteria;
        temp_searchcriteria.paymentMethodCode = paymentTypeCodeBean.code;
        this.setState({
          searchCriteria: temp_searchcriteria,
          paymentTypePageListForAutoCompleteList: new Array(),
        });
      }
    };
    displayAutoCompletePaymentTypeList = (showAutoCompleteList) => {
      this.setState({ showAutoCompletePaymentTypeList: showAutoCompleteList });
    };
    displayAutoCompletePaymentTermList = (showAutoCompleteList) => {
      this.setState({ showAutoCompletePaymentTermList: showAutoCompleteList });
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      const is3PL = this.state.is3PL;
      return (
        <div>
          <ProgressBar
            progressLoadingText={this.state.progressLoadingText}
            isShowPopup={this.state.isShowProgressBarPopup}
          />
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>SO#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="soNumber"
                  name="salesOrderNumber"
                  onChange={this.onChange}
                  value={searchCriteria.salesOrderNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>salesOrderNumberStartsWith#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="salesOrderNumberStartsWith"
                  name="salesOrderNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.salesOrderNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>salesOrderNumberContains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="salesOrderNumberContains"
                  name="salesOrderNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.salesOrderNumberContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="orderStatus"
                  value={searchCriteria.orderStatus}
                >
                  <option value={""}></option>
                  <option value={"A"}>Approve</option>
                  <option value={"U"}>UnApprove</option>
                  <option value={"M"}>Picked</option>
                  <option value={"L"}>Partially Picked</option>
                  <option value={"F"}>Invoiced / Finished</option>
                  <option value={"G"}>Partially Invoiced</option>
                  <option value={"X"}>Cancelled</option>
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>OrderType</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="orderTypeCode"
                  name="orderTypeCode"
                  onChange={this.onChange}
                  value={searchCriteria.orderTypeCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Customer</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="customerCode"
                  name="customerCode"
                  onChange={this.customerCodeOnChange}
                  value={searchCriteria.customerCode}
                  lookupRequired={true}
                  lookupHandler={this.state.customerLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.customerPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteList}
                  showAutoCompleteList={this.state.showAutoCompleteCustomerList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                {is3PL ? (
                  <FormLabel>Item</FormLabel>
                ) : (
                  <FormLabel>FabricStyle#</FormLabel>
                )}
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="fabricStyleCode"
                  name="fabricStyleCode"
                  value={searchCriteria.fabricStyleCode}
                  onChange={this.fabricCodeOnChange}
                  lookupRequired={true}
                  lookupHandler={this.state.fabricLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.fabricEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.fabricPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteFabricList}
                  showAutoCompleteList={this.state.showAutoCompleteFabricList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>CustomerPO StartsWith</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="customerPurchaseOrderNumberStartsWith"
                  name="customerPurchaseOrderNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.customerPurchaseOrderNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>CustomerPO Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="customerPurchaseOrderNumberContains"
                  name="customerPurchaseOrderNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.customerPurchaseOrderNumberContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Payment Term</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="paymentTermCode"
                  name="paymentTermCode"
                  onChange={this.onPaymentTermChange}
                  value={searchCriteria.paymentTermCode}
                  lookupRequired={true}
                  lookupHandler={this.state.paymentTermLookupHandler}
                  enterKeyEventHandler={this.paymentTermEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.paymentTermPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompletePaymentTermList
                  }
                  showAutoCompleteList={
                    this.state.showAutoCompletePaymentTermList
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Payment Method</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="paymentMethodCode"
                  name="paymentMethodCode"
                  onChange={this.onPaymentTypeChange}
                  value={searchCriteria.paymentMethodCode}
                  lookupRequired={true}
                  lookupHandler={this.state.paymentMethodLookupHandler}
                  enterKeyEventHandler={this.paymentTypeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.paymentTypePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompletePaymentTypeList
                  }
                  showAutoCompleteList={
                    this.state.showAutoCompletePaymentTypeList
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>ShipVia</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="shipViaCode"
                  name="shipViaCode"
                  onChange={this.onShipViaChange}
                  value={searchCriteria.shipViaCode}
                  lookupRequired={true}
                  lookupHandler={this.state.shipViaLookupHandler}
                  enterKeyEventHandler={this.shipViaEnterKeyEvent}
                  autoCompleteListData={
                    this.state.shipViaPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteShipViaList}
                  showAutoCompleteList={this.state.showAutoCompleteShipViaList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Created Date</FormLabel>
              </Col>
              <Col sm={7}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="createdDate"
                  name="createdDate"
                  onChange={this.onChange}
                  value={searchCriteria.createdDate}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <FormLabel>Stop Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="orderStopDatefrom"
                  name="orderStopDatefrom"
                  onChange={this.onChange}
                  value={searchCriteria.orderStopDatefrom}
                />
              </Col>
              <Col sm={1}>
                <FormLabel>To</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  tabIndex={-1}
                  id="orderStopDateTo"
                  name="orderStopDateTo"
                  onChange={this.onChange}
                  value={searchCriteria.orderStopDateTo}
                />
              </Col>
            </Row>
            <div className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
